import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketSelectSectionTemplate from './BasketSelectSectionTemplate';
import { rem } from 'polished';

export const BasketSelectSectionStyled = styled(BasketSelectSectionTemplate)`
    .sections {
        margin: ${rem(16)} 0 0 0;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .leftSection {
            margin: ${rem(13)} 0;

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 ${rem(8)} 0 0;
            }
        }

        .rightSection {
            margin: ${rem(13)} 0;

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 0 0 ${rem(8)};
            }
        }

        .leftSection,
        .rightSection {
            cursor: pointer;
            width: 100%;
            border: 1px solid ${({ theme }) => theme.colors.grey25};
            height: ${rem(125)};
            background: none;
            display: flex;
            flex-direction: column;
            text-align: left;
            padding: 0;

            &:hover,
            &:focus-visible,
            &.selected {
                border: 1px solid ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.primaryLight};
                .inner {
                    border: 1px solid ${({ theme }) => theme.colors.primary};
                }
            }

            .inner {
                width: 100%;
                height: 100%;
                padding: ${rem(16)} ${rem(8)} 0 ${rem(60)};
                border: 1px solid transparent;
            }

            @media (min-width: ${breakpoints.xs}px) {
                height: ${rem(109)};

                .inner {
                    padding: ${rem(26)} ${rem(8)} 0 ${rem(64)};
                }
            }

            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }

            .title {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                display: block;
                padding-bottom: ${rem(3)};
                position: relative;

                .icon {
                    border: 1px solid #73767a;
                    width: ${rem(24)};
                    height: ${rem(24)};
                    position: absolute;
                    left: -${rem(40)};
                    top: -${rem(2)};
                    border-radius: 50%;

                    .selected {
                        background: ${({ theme }) => theme.colors.primary};
                        width: ${rem(12)};
                        height: ${rem(12)};
                        position: absolute;
                        top: ${rem(5)};
                        left: ${rem(5)};
                        border-radius: 50%;
                    }
                }
            }

            .description {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                color: ${({ theme }) => theme.colors.grey27};
            }
        }
    }
`;
